export const getUserDocs = async (cK) => {
	const data = {caseKey: cK};
	return await fetch("./getUserDocs.php", {
		method: "POST",
		body: JSON.stringify(data),
	})
	.then((res) => res.json())
	.then((data) => data);
};

export const patchDocActioned = async (documentCode) => {
	const data = {DocumentCode: documentCode};
	return await fetch("./patchDocActioned.php", {
		method: "POST",
		body: JSON.stringify(data),
	})
	.then(
		(res) => res.json()
	)
	.then(
		(data) => data
	);
};

export const getCaseLogins = async (ck) => {
	const data = {casekey: ck};
	return await fetch("./getCaseLogins.php", {
		method: "POST",
		body: JSON.stringify(data),
	})
	.then(
		(res) => res.json()
	)
	.then(
		(data) => data
	);
};